import { render, staticRenderFns } from "./Acreditacao.vue?vue&type=template&id=fe3fe0b8&scoped=true"
import script from "./Acreditacao.vue?vue&type=script&lang=js"
export * from "./Acreditacao.vue?vue&type=script&lang=js"
import style0 from "./Acreditacao.vue?vue&type=style&index=0&id=fe3fe0b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3fe0b8",
  null
  
)

export default component.exports